import { gql } from "@apollo/client";

export const GET_ALL_ANNOUNCEMENTS=gql`
query getAllAnnouncements($searchInput: String = "%", $limit: Int = null, $offset: Int = null) {
  allAnnouncements(
    orderBy: UPDATED_AT_DESC
    filter: {aOriginalTitle: {likeInsensitive: $searchInput}, deletedAt: {isNull: true}}
    first: $limit
    offset: $offset
  ) {
    nodes {
      aId
      aTitle
      aOriginalTitle
      aMessage
      aUrl
      saId
      isShare
      updatedAt
      feedsByAId(filter: {userFeedsByFIdExist: false}) {
        nodes {
          fId
        }
      }
    }
    totalCount
  }
}`;

export const CREATE_ANNOUNCEMENT=gql`
mutation createAnnouncement($input: announcementInput!) {
  createNewAnnouncement(input: $input)
}
`;

export const UPDATE_ANNOUNCEMENT=gql`
mutation updateAnnouncement($aId: String!, $input: announcementInput!) {
  updateAnnouncementByaId(aId: $aId, input: $input)
}
`;

export const DELETE_ANNOUNCEMENT=gql`
mutation deleteAnnouncement($aId: String!) {
  deleteAnnouncementByaId(aId: $aId)
}
`;

export const SHARE_TO_ALL_ANNOUNCEMENT = gql`
mutation updateAnnouncementStatus($aId: String!, $isShare: Boolean!) {
  updateAnnouncementStatus(aId: $aId, isShare: $isShare)
}
`;